(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('PlanDeEstudios', PlanDeEstudios);

    PlanDeEstudios.$inject = ['$resource'];

    function PlanDeEstudios ($resource) {
        var resourceUrl =  'api/plan-de-estudios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
